'use client';

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { Block } from "./Block.mjs";
var defaultComponents = {
  blocks: {
    paragraph: function paragraph(props) {
      return /* @__PURE__ */jsx("p", {
        children: props.children
      });
    },
    quote: function quote(props) {
      return /* @__PURE__ */jsx("blockquote", {
        children: props.children
      });
    },
    code: function code(props) {
      return /* @__PURE__ */jsx("pre", {
        children: /* @__PURE__ */jsx("code", {
          children: props.plainText
        })
      });
    },
    heading: function heading(_ref) {
      var level = _ref.level,
          children = _ref.children;

      switch (level) {
        case 1:
          return /* @__PURE__ */jsx("h1", {
            children: children
          });

        case 2:
          return /* @__PURE__ */jsx("h2", {
            children: children
          });

        case 3:
          return /* @__PURE__ */jsx("h3", {
            children: children
          });

        case 4:
          return /* @__PURE__ */jsx("h4", {
            children: children
          });

        case 5:
          return /* @__PURE__ */jsx("h5", {
            children: children
          });

        case 6:
          return /* @__PURE__ */jsx("h6", {
            children: children
          });
      }
    },
    link: function link(props) {
      return /* @__PURE__ */jsx("a", {
        href: props.url,
        children: props.children
      });
    },
    list: function list(props) {
      if (props.format === "ordered") {
        return /* @__PURE__ */jsx("ol", {
          children: props.children
        });
      }

      return /* @__PURE__ */jsx("ul", {
        children: props.children
      });
    },
    "list-item": function listItem(props) {
      return /* @__PURE__ */jsx("li", {
        children: props.children
      });
    },
    image: function image(props) {
      return /* @__PURE__ */jsx("img", {
        src: props.image.url,
        alt: props.image.alternativeText || void 0
      });
    }
  },
  modifiers: {
    bold: function bold(props) {
      return /* @__PURE__ */jsx("strong", {
        children: props.children
      });
    },
    italic: function italic(props) {
      return /* @__PURE__ */jsx("em", {
        children: props.children
      });
    },
    underline: function underline(props) {
      return /* @__PURE__ */jsx("u", {
        children: props.children
      });
    },
    strikethrough: function strikethrough(props) {
      return /* @__PURE__ */jsx("del", {
        children: props.children
      });
    },
    code: function code(props) {
      return /* @__PURE__ */jsx("code", {
        children: props.children
      });
    }
  },
  missingBlockTypes: [],
  missingModifierTypes: []
};
var ComponentsContext = React.createContext(defaultComponents);

var ComponentsProvider = function ComponentsProvider(_ref2) {
  var children = _ref2.children,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? defaultComponents : _ref2$value;
  var memoizedValue = React.useMemo(function () {
    return value;
  }, [value]);
  return /* @__PURE__ */jsx(ComponentsContext.Provider, {
    value: memoizedValue,
    children: children
  });
};

function useComponentsContext() {
  return React.useContext(ComponentsContext);
}

var BlocksRenderer = function BlocksRenderer(props) {
  var blocks = _objectSpread(_objectSpread({}, defaultComponents.blocks), props.blocks);

  var modifiers = _objectSpread(_objectSpread({}, defaultComponents.modifiers), props.modifiers);

  var missingBlockTypes = React.useRef([]);
  var missingModifierTypes = React.useRef([]);
  return /* @__PURE__ */jsx(ComponentsProvider, {
    value: {
      blocks: blocks,
      modifiers: modifiers,
      missingBlockTypes: missingBlockTypes.current,
      missingModifierTypes: missingModifierTypes.current
    },
    children: props.content.map(function (content, index) {
      return /* @__PURE__ */jsx(Block, {
        content: content
      }, index);
    })
  });
};

export { BlocksRenderer, ComponentsProvider, useComponentsContext };